import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

function assertSixPositiveAmounts(value: unknown): readonly number[] {
	if (!Array.isArray(value)) throw new Error('amounts must be an array');
	if (value.length !== 6) throw new Error(`amounts must have exactly 6 values, got ${value.length}`);
	if (!value.every((amount) => typeof amount === 'number' && amount > 0)) {
		throw new Error('amounts must all be positive numbers');
	}
	return value as readonly number[];
}

export const FCM_PROMOTE_BONUS_BANNER_EXPERIMENT = defineFcm('promote_bonus_banner_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
				countryCode: { type: 'string', optional: true },
				variant_2: {
					type: 'object',
					shape: {
						amounts: { type: 'array', shape: { type: 'number' }, normalizer: assertSixPositiveAmounts },
					},
					optional: true,
				},
				exclusion_group_experiment_id: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'promote',
		description:
			"Promote page bonus banner experiment. countryCode is the country the experiment runs in (must match the user's country). variant_2.amounts is the six-amount ladder shown in variant_2, in the market's currency. exclusion_group_experiment_id is the member id to check this experiment against in FCM_PROMOTE_PAGE_EXCLUSION_GROUP; leave unset to run unconditionally, bypassing the exclusion group entirely.",
		supportedGroups: { locales: true, countries: true },
		template: {
			experimentName: '',
			countryCode: 'US',
			variant_2: { amounts: [5, 30, 50, 100, 250, 500] },
			exclusion_group_experiment_id: 'promote_bonus_banner_experiment',
		},
	});
